import { jsx } from 'react/jsx-runtime';
import classnames from 'classnames';
import cn from 'classnames/bind';
import { Slot } from 'radix-ui';
import classes from './index.module.scss.js';

const cx = cn.bind(classes);
const Badge = ({ classes = [], children, themed = false, inverted = false, rounded = false, flavor = 'normal', asChild = false, ...rest }) => {
    const cls = classnames(flavor === 'normal' ? 'overline' : 'caption', 'small', ...classes, cx('badge', { themed, inverted, rounded }));
    const Comp = asChild ? Slot.Root : 'span';
    return (jsx(Comp, { className: cls, ...rest, children: children }));
};
Badge.displayName = 'Badge';

export { Badge };
//# sourceMappingURL=index.js.map
